import React from "react";
import { CourseContentManager } from "./CourseContentManager";

// The administrator retains its own route and role-specific course navigation.
export const AdminPaginaContenido = () => <CourseContentManager />;
